export default {
  title: '價格表資料',
  schema: {
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        required: true,
        name: '價格表名稱',
      },
      '@order': {
        type: 'Number',
        name: '排序',
      },
      currency: {
        type: 'String',
        name: '幣別',
        options: ['TWD', 'EUR', 'USD', 'RMB'],
      },
      buyOrSale: {
        type: 'String',
        name: '進或售',
        // required: true,
        options: ['進價', '售價'],
      },
      multiplier: {
        type: 'Number',
        name: '乘數',
      },
      note: {
        type: 'String',
        input: 'textarea',
        name: '價格表說明',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'key', width: 120 },
        { path: 'currency' },
        { path: 'multiplier' },
        { path: 'buyOrSale' },
        { path: '@order' },
      ],
    },
  },
  edit: {
    ui: {
      form: {
        name: 'formEditor',
        fields: [
          ['key'],
          ['@order', 'currency'],
          ['multiplier', 'buyOrSale'],
          ['note'],
        ],
      },
    },
  },
}
